<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params }">
      <Details v-if="visible" :rows="params"></Details>
    </template>
  </cTable>
</template>

<script>
import {
  getHwBillBranch,
  delHwBill,
  updateHwBill,
  confirmBill,
  auditBill,
  resetHwAmount,
  appendCnbNo,
} from "@/api/finance/hw_bill_branch";
import {
  getConfig,
  ConversionUsd,
  getUsdRate,
  getMonthUsers,
  createMonthUserBill,
  exportMonthBill,
  exportAllBill,
  getOperator,
} from "@/api/finance/bill";
import { getCompanies } from "@/api/user/client";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import Details from "./details";
export default {
  name: "hw_bill_branch",
  components: {
    cTable,
    Details,
  },
  data() {
    let options = [
      { label: this.$t("month_t"), value: "MONTH" },
      { label: this.$t("half_moon"), value: "HALFMONTH" },
      { label: this.$t("week"), value: "WEEK" },
      { label: this.$t("day"), value: "DAY" },
    ];
    return {
      methods: {
        list: getHwBillBranch,
        delHwBill,
        getConfig,
        updateHwBill,
        confirmBill,
        auditBill,
        resetHwAmount,
        appendCnbNo,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          this.totalAmount.push({
            text: this.$t("total"),
            replace_currency: "",
            total_amount: data.totalAmount,
          });
        },
        ConversionUsd,
        createMonthUserBill,
        getUsdRate,
        getMonthUsers,
        exportMonthBill,
        exportAllBill,
        getOperator,
      },
      totalAmount: [],
      modals: {
        append: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods("appendCnbNo", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_numbers: [
                {
                  required: true,
                  message: "Please Enter airway_number",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ airway_numbers: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_numbers",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 10,
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = { period: row.period };
              data.client_id = this.selectAll.map((item) => item.client_id);
              this.$page
                .handleRequestMethods("saveHwBill", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              period: [
                {
                  required: true,
                  message: "Please select period",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ period: 24 }, { client: 24 }],
          fields: [
            {
              name: () => this.$t("period"),
              key: "period",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("period"),
              options: options,
              methods: {
                async "on-change"({ formData }) {
                  try {
                    this.$page.getModal("add").list = [];
                    if (formData.period) {
                      let data = (
                        await this.$page.handleRequestMethods(
                          "getHwBillClient",
                          this.formData
                        )
                      ).payload;
                      this.$page.getModal("add").client = this.$page.getModal(
                        "add"
                      ).list = data;
                    }
                  } catch (error) {}
                },
              },
            },
            {
              name: () => this.$t("clientName"),
              key: "client",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("clientName") + this.$t("search"),
              methods: {
                "on-search"({ formData }) {
                  if (this.$page.getModal("add").list.length == 0) {
                    this.$Message["error"]({
                      background: true,
                      content: this.$t("select") + this.$t("period"),
                      duration: 5,
                    });
                    return;
                  }
                  let arr = this.$page.getModal("add").client;
                  if (formData.client == "") {
                    this.$page.getModal("add").list = arr;
                    return;
                  }
                  this.$page.getModal("add").list = arr.filter(
                    (item) =>
                      item.account
                        .toLowerCase()
                        .indexOf(formData.client.toLowerCase()) !== -1
                  );
                },
              },
              bind: {
                suffix: "ios-search",
                search: true,
              },
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
                fixed: "left",
              },
              {
                name: () => this.$t("clientName"),
                align: "left",
                key: "account",
                minWidth: 100,
              },
              {
                name: () => this.$t("period"),
                key: "billing_cycle",
                align: "center",
                minWidth: 100,
                methods: {
                  render() {
                    return options.find(
                      (item) =>
                        item.value ==
                        this.getModal("add").$refs["form"].formData.period
                    ).label;
                  },
                },
              },
              {
                name: () => this.$t("salesman"),
                key: "salesman_account",
                align: "left",
                minWidth: 100,
              },
            ],
          },
        },
        update: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("updateHwBill", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "Please Enter rate",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ name: 24 }, { rate: 24 }],
          fields: [
            {
              name: () => "CNY TO USD",
              key: "rate",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },

            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("auditBill", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 30,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              // client_id: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              transfer_method: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              transaction_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { status: 24 },
            // { client_id: 24 },
            // { o_type: 24 },
            { bank_id: 24 },
            { bank: 24 },
            { check_amount: 24 },
            { check_amount_currency: 24 },
            { transaction_id: 24 },
            { remarks: 24 },
          ],
          fields: [
            // {
            //   name: () => this.$t("clientName"),
            //   key: "client_id",
            //   component: "Select",
            //   options: [],
            //   config: {
            //     label({ row }) {
            //       return row.account + "(" + row.account_balances + ")";
            //     },
            //     value: "id"
            //   },
            //   placeholder: () => this.$t("select") + this.$t("clientName"),
            //   methods: {
            //     async list({ field, row }) {
            //       field.options = (
            //         await this.$page.handleRequestMethods(
            //           "getBillClients",
            //           this.$modal.params.id
            //         )
            //       ).payload;
            //       row["client_id"] = field.options[0].id;
            //       this.$forceUpdate();
            //     }
            //   },
            //   show({ row }) {
            //     return row.status == 1;
            //   }
            // },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                { label: this.$t("refuse"), value: 0 },
                { label: this.$t("allow"), value: 1 },
              ],
              default: 0,
              bind: {
                border: true,
              },
            },
            // {
            //   name: () => "核销方式",
            //   key: "o_type",
            //   component: "Radio",
            //   options: [
            //     { label: this.$t('onLine'), value: 1 },
            //     { label: this.$t('offLine'), value: 2 }
            //   ],
            //   default: 2,
            //   bind: {
            //     border: true
            //   },
            //   show({ row }) {
            //     return row.status == 1;
            //   }
            // },
            {
              name: this.$t("bank"),
              key: "bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label: ({ row }) => {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "account_type",
              },
              show({ row }) {
                return row.status == 1;
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
                click({ obj, formData }) {
                  formData.bank_id = obj.id;
                },
              },
            },
            {
              name: this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("check_amount"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
              show({ row }) {
                return row.status == 1;
              },
            },
            {
              name: this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [
                {
                  label: this.$t("to_rmb"),
                  value: "CNY",
                },
                {
                  label: this.$t("to_usd"),
                  value: "USD",
                },
              ],
              show({ row }) {
                return row.status == 1;
              },
            },
            {
              name: this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
              show({ row }) {
                return row.status == 1;
              },
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5,
              },
              show({ row }) {
                return row.status == 1;
              },
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: { show: () => false },
        },
      },
      footer: {
        show: () => true,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  ),
                ]
              );
            })
          );
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          // {
          //   key: "time_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   component: "Select",
          //   options: []
          // },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            options: [],
          },
          // {
          //   key: "clientId",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label: "account",
          //     value: "id"
          //   }
          // },
          {
            key: "operator_id",
            placeholder() {
              return this.$t("select") + this.$t("status_operator");
            },
            component: "Select",
            options: [],
            // config: {
            //   label: "account",
            //   value: "id"
            // }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 567,
            },
            {
              name: this.$t("export"),
              // type: "export",
              // fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary",
              },
              list: [
                {
                  name: this.$t("ListData"),
                  type: "export",
                  fnName: "export",
                  disabled() {
                    return !this.selectAll.length;
                  },
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                },
                // {
                //   name: "月账单",
                //   type: "monthBill",
                //   fnName: "monthBill",
                //   disabled() {
                //     return !this.selectAll.length;
                //   }
                //   // bind: {
                //   //   icon: "md-arrow-down",
                //   //   type: "primary"
                //   // }
                // },
                // {
                //   name: this.$t('summary') + this.$t('export'),
                //   type: "allBill",
                //   fnName: "allBill",
                //   disabled() {
                //     return !this.selectAll.length;
                //   }
                //   // bind: {
                //   //   icon: "md-arrow-down",
                //   //   type: "primary"
                //   // }
                // }
              ],
            },
            // {
            //   name: () => this.$t("writeOff"),
            //   type: "writeOff",
            //   fnName: "writeOff",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            allBill() {
              let data = {
                bill_id: this.selectAll.map((item) => item.id),
              };
              this.openLoading();
              this.handleRequestMethods("exportAllBill", data).then((res) => {
                window.open(this.$globalUrl + res.payload);
                this.closeLoading();
              });
            },
            monthBill() {
              let data = {
                id: this.selectAll.map((item) => item.id),
              };
              this.openLoading();
              this.handleRequestMethods("exportMonthBill", data).then((res) => {
                window.open(this.$globalUrl + res.payload);
                this.closeLoading();
              });
            },
            add() {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").type = "add";
              this.getModal("add").open();
            },
            // writeOff() {
            //   this.getModal("writeOff").setTitle(this.$t("writeOff"));
            //   this.getModal("writeOff").type = "batchWriteOff";
            //   this.getModal("writeOff").open();
            // }
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          align: "center",
          // component: this.$hasPermission(568) ? "Button" : "span",
          component: "Button",
          minWidth: 200,
          copy: true,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render({ row }) {
              return row.bill_number;
            },
            click({ row }) {
              // if (!this.$hasPermission(568)) return;
              this.$page.getModal("showDetails").open(row, function () {
                this.setTitle(row.bill_number);
              });
            },
          },
        },
        {
          name: () => this.$t("codNAme"),
          align: "center",
          key: "name",
          minWidth: 100,
        },
        {
          name: () => this.$t("orderNums"),
          key: "order_nums",
          align: "center",
          minWidth: 80,
        },
        // {
        //   name: () => this.$t("total_votes"),
        //   align: "center",
        //   key: "total_votes",
        //   width: 80
        // },
        // {
        //   name: () => this.$t("amount") + "(CNY)",
        //   key: "total_cny",
        //   align: "center",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("amount") + "(USD)",
        //   align: "center",
        //   key: "total_usd",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("rate") + "(USD-CNY)",
        //   align: "center",
        //   key: "usd_to_cny_rate",
        //   width: 130
        // },
        {
          name: () => this.$t("total_amount") + "(CNY)",
          align: "center",
          key: "amount",
          width: 110,
        },
        {
          name: () => this.$t("total_amount") + "(USD)",
          align: "center",
          key: "amount_usd",
          width: 110,
        },
        {
          name: () => "CNY to USD",
          align: "center",
          key: "cny_to_usd_rate",
          width: 110,
        },
        // {
        //   name: () => this.$t("clientName"),
        //   align: "center",
        //   key: "clientInfo",
        //   width: 100,
        //   methods: {
        //     render({ value }) {
        //       return value && value.account;
        //     }
        //   }
        // },
        {
          name: () => this.$t("clientName"),
          align: "center",
          key: "ownership_name",
          width: 100,
        },
        {
          name: () => this.$t("status_operator"),
          align: "center",
          key: "operator_name",
          width: 100,
          // methods: {
          //   render({ value }) {
          //     return value && value.account;
          //   }
          // }
        },
        {
          name: () => this.$t("audit"),
          align: "center",
          key: "auditInfo",
          width: 100,
          methods: {
            render({ value }) {
              return value && value.account;
            },
          },
        },
        {
          name: () => this.$t("createTime"),
          align: "center",
          key: "create_time",
          width: 170,
        },
        {
          name: () => this.$t("confirm_time"),
          key: "confirm_time",
          align: "center",
          minWidth: 170,
        },
        {
          name: () => this.$t("audit_time"),
          key: "audit_time",
          align: "center",
          minWidth: 170,
        },
        {
          name: () => this.$t("paid_time"),
          key: "paid_time",
          align: "center",
          minWidth: 170,
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("b2bClient") + this.$t("order_desc"),
          key: "client_remarks",
          align: "center",
          minWidth: 100,
        },
        // {
        //   name: () => this.$t("b2bClient") + this.$t("order_desc"),
        //   key: "client_remarks",
        //   align: "center",
        //   minWidth: 170
        // },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 300,
          fixed: "right",
          list: [
            {
              name: () => this.$t("addTo"),
              type: "append",
              fnName: "append",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status != "WAIT_CONFIRM";
              },
              // id: 365
            },
            {
              name: () => this.$t("resAmount"),
              type: "resetAmount",
              fnName: "resetAmount",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.status != "WAIT_CONFIRM";
              },
              // id: 569
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.status == "WAIT_CONFIRM" || row.status == "DISAGREE"
                  ? false
                  : true;
              },
              // id: 571
            },
            {
              name: () => this.$t("confirmOrder"),
              type: "confirmOrder",
              fnName: "confirmOrder",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status != "WAIT_CONFIRM";
              },
              // id: 572
            },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status != "CONFIRMED";
              },
              // id: 573
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              // disabled({ row }) {
              //   return row.status != "WAIT_CONFIRM";
              // }
              // id: 570
            },
          ],
          methods: {
            append({ row }) {
              this.getModal("append").open({ id: row.id }, function () {
                this.setTitle(this.$t("addTo"));
              });
            },
            resetAmount({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("resAmount"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.openLoading();
                  this.handleRequestMethods("resetHwAmount", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            add({ row }) {
              this.getModal("add").open({ id: row.id });
            },
            update({ row }) {
              this.getModal("update").open(
                {
                  name: row.name,
                  rate: parseFloat(row.cny_to_usd_rate),
                  id: row.id,
                },
                function () {
                  this.setTitle(
                    this.$t("bill1") +
                      "(" +
                      row.bill_number +
                      ")" +
                      this.$t("update")
                  );
                }
              );
            },
            confirmOrder({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + +this.$t("confirmOrder"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("confirmBill", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            writeOff({ row }) {
              this.getModal("writeOff").open({ id: row.id }, function () {
                this.setTitle(
                  this.$t("bill1") +
                    "(" +
                    row.bill_number +
                    ")" +
                    this.$t("writeOff")
                );
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("delHwBill", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  activated() {
		if(this.$store.state.user.pageUrl){
			this.$refs["table"].$refs["header"].searchForm.keywords =
			  this.$store.state.user.pageUrl;
			this.$store.state.user.pageUrl = "";
			this.$refs["table"].getList();
		}
    
  },
  async mounted() {
    let data = (await getConfig()).data.payload;
    // let client = (await getAllClient()).data.payload.rows;
    let operator = (await getOperator()).data.payload;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "status")
        item.options = Object.keys(data.status).map((item) => ({
          value: item,
          label: data.status[item],
        }));
      // if (item.key === "clientId") item.options = client;
      if (item.key === "operator_id") item.options = operator;
      if (item.key === "ownership")
        item.options = (await getCompanies()).data.payload;
    });
  },
};
</script>
